import { InstagramUserImage, TiktokUserImage, getInstagramUserImages, getTiktokUserImages } from '@round/api';

const fetchTiktokUserImages = async (ids: number[], requestInit?: RequestInit) => {
    if (!ids.length) {
        return [];
    }

    return getTiktokUserImages(ids, requestInit);
};

const fetchInstagramImages = async (ids: number[], requestInit?: RequestInit) => {
    if (!ids.length) {
        return [];
    }

    return (await getInstagramUserImages(ids, requestInit)).data;
};

export async function fetchUserImages(
    { tiktokUserIds, instagramUserIds }: { tiktokUserIds?: number[]; instagramUserIds?: number[] },
    requestInit?: RequestInit
) {
    const [tiktokImagesResult, instagramImagesResult] = await Promise.allSettled([
        fetchTiktokUserImages(tiktokUserIds || [], requestInit),
        fetchInstagramImages(instagramUserIds || [], requestInit),
    ]);

    const tiktokImages: TiktokUserImage[] = tiktokImagesResult.status === 'fulfilled' ? tiktokImagesResult.value : [];
    const instagramImages: InstagramUserImage[] =
        instagramImagesResult.status === 'fulfilled' ? instagramImagesResult.value : [];

    return [tiktokImages, instagramImages];
}
